import { useState, useEffect } from 'react'

import { history } from 'services/history.js'
import { showLoading } from 'services/util'

import { adminCleanupPreviewAuction, areAllChargesPaid, auctionDetailsComplete, auctionHasItems, sendSolicitationReviewRequest, solicitationStatusDecoder } from './auctionsadminutil'
import { canEditAuction, isAuctionOwner } from './permissionsutil'

import adminCss from './sass/adminpage.module.scss'
import themeCss from '../components/sass/theme.module.scss'
import PreviewPublishChecklist from './PreviewPublishChecklist'
import UpdateAuctionStatusButton from './UpdateAuctionStatusButton'
import AuctionStatusAlert from './AuctionStatusAlert'
import ExtendAuctionButton from './ExtendAuctionButton'
import ConfirmLeavePage from './ConfirmModal/ConfirmLeavePage'
import ConfirmSolicitationRequest from './ConfirmModal/ConfirmSolicitationRequest'
import { setSessionItem } from '../components/utils'
import SolicitationReviewButton from './SolicitationReviewButton'

export default function PreviewPublish(props) {

  console.log(props)

  const reviewStatus = props.auctionDetail?.ReviewStatus
  const passedReview = reviewStatus === 'Approved'
  const submittedForReview = reviewStatus === 'Submitted' || reviewStatus === 'Removed'

  const [readyForSR, setReadyForSR] = useState(false)
  const [allItemsPaid, setAllItemsPaid] = useState(false)
  const [solicitationError, setSolicitationError] = useState('')

  const isUserSR = localStorage.getItem('isSolicitationReviewAdmin')

  //modal variables for unsaved auction checks
  const [showModal, setShowModal] = useState(false)

  // Controls the confirmation modal shown before an approval request is sent to Solicitation Review.
  const [showConfirmSolicitationRequestModal, setShowConfirmSolicitationRequestModal] = useState(false)

  useEffect(() => {

    if (!props.auctionDetail) return
    const detailsComplete = auctionDetailsComplete(props.auctionDetail)
    const anyItems = auctionHasItems(props.auctionDetail)

    if (!detailsComplete || !anyItems) setReadyForSR(false)
    else setReadyForSR(true)

    // check to see if all items are paid for, to allow for archiving auctions
    setAllItemsPaid(areAllChargesPaid(props.auctionDetail))
  }, [props.auctionDetail])

  // The request remains here so PreviewPublish continues to own its error message and auction refresh state.
  const sendToSolicitation = async () => {
    console.log('send email request for solicitation review')
    setSolicitationError('')
    showLoading(true)
    const response = await sendSolicitationReviewRequest(props.auctionDetail.AuctionId)
    //if there is an error, display underneath solicitation review button
    if (response?.error?.errors[0].message.length > 0) setSolicitationError(response.error.errors[0].message)

    props.refreshAdminAuctionQuery()
    console.log({ response })
    showLoading(false)
  }

  const auctionStatus = props.auctionDetail?.Status

  const doPreview = async () => {
    const stored = sessionStorage.getItem('unsavedAuction')

    //if there is unsaved auction, show the confirm modal
    if (stored && stored !== 'null' && showModal === false) {
      setShowModal(true)
      return
    }

    await adminCleanupPreviewAuction(props.auctionDetail.AuctionId)
    history.push({ pathname: '/flow/auction', search: `?isPreview=true&auctionId=${props.auctionDetail.AuctionCode}` })
  }

  const confirmLeave = () => {
    setSessionItem('unsavedAuction', null)
    // Directly remove the beforeunload handler before navigation
    // This prevents any Chrome popups during intentional navigation
    if (window.removeAuctionEditBeforeUnload) {
      window.removeAuctionEditBeforeUnload()
    }
    doPreview()
    setShowModal(false)
  }

  return (
    <div className={adminCss['widget-container']}>
      {showModal && <ConfirmLeavePage setShowConfirmModal={setShowModal} confirmLeave={confirmLeave} />}
      {showConfirmSolicitationRequestModal &&
        <ConfirmSolicitationRequest
          setShowConfirmModal={setShowConfirmSolicitationRequestModal}
          sendToSolicitation={sendToSolicitation}
        />}
      <div className={adminCss['widget-status-container']}>
        <div>
          <AuctionStatusAlert liveStatus={props.liveStatus} auctionStatus={auctionStatus} />
          {auctionStatus === 'PUBLIC' &&
            <button onClick={e => history.push({ pathname: '/auctionhome', search: `?auctionId=${props.auctionDetail.AuctionCode}` })}
              className={`${themeCss['FilledBlue']} ${themeCss['button']}`}
            >Go To Auction</button>}
        </div>
        <PreviewPublishChecklist liveStatus={props.liveStatus} auctionDetail={props.auctionDetail} location={'widget'} />
      </div>

      {auctionStatus === 'PREVIEW' && <div className={adminCss['widget-button-container']}>

        <button className={`${themeCss['button']} ${themeCss['FilledWhite']}`} onClick={doPreview}>Preview Test Site</button>

        {!passedReview && !submittedForReview && isAuctionOwner(props.auctionDetail) &&
          <>
            <button className={`${themeCss['button']} ${themeCss['FilledWhite']}`}
              disabled={!readyForSR}
              title={readyForSR ? '' : 'All Auction Details and Items are all required before sending to Solicitation Review'}
              onClick={() => setShowConfirmSolicitationRequestModal(true)}>
              Send Approval Request to Solicitation Review
            </button>

            {solicitationError.length > 0 && <p className={adminCss['solicitation-warning-nonadmin']}>{solicitationError}</p>}
          </>
        }

        <div className={adminCss['solicitation-input-container']}>
          <p>Solicitation Review Status:
            <span className={adminCss[`${reviewStatus}`]}>{reviewStatus ? solicitationStatusDecoder[reviewStatus] : 'Not submitted'}</span>
          </p>
        </div>


        {isUserSR ? 
          <SolicitationReviewButton auctionDetail={props.auctionDetail} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} />
          : <UpdateAuctionStatusButton auction={props.auctionDetail} fromStatus={'PREVIEW'} toStatus={'PUBLIC'} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery}
            needsSolicitation={!passedReview} />}
      </div>}

      {auctionStatus === 'PUBLIC' && <div className={adminCss['widget-button-container']}>
        {/* from public to preview is prevented in UpdateAuctionStatus
        <UpdateAuctionStatusButton auction={props.auctionDetail} fromStatus={'PUBLIC'} toStatus={'PREVIEW'} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} /> */}
        {props.liveStatus === 'started' && canEditAuction(props.auctionDetail) &&
          <div className={adminCss['started-button-container']}>
            <ExtendAuctionButton auction={props.auctionDetail} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} />
            <UpdateAuctionStatusButton auction={props.auctionDetail} fromStatus={'PUBLIC'} toStatus={'ENDED'} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} />
          </div>}
        {props.liveStatus === 'ended' && isAuctionOwner(props.auctionDetail) && <>
          <UpdateAuctionStatusButton auction={props.auctionDetail} fromStatus={'PUBLIC'} toStatus={'CLOSED'} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} />
          {allItemsPaid ? 
            <p className={adminCss['archive-warning-red']}>Once archived, the auction site is taken offline. Payments can not be completed.</p> : 
            <p className={adminCss['archive-warning']}>Outstanding payments must be resolved before the auction site can be archived.</p>}
        </>}
      </div>}
      {auctionStatus === 'CLOSED' && <div>
        <UpdateAuctionStatusButton auction={props.auctionDetail} fromStatus={'CLOSED'} toStatus={'PUBLIC'} refreshAdminAuctionQuery={props.refreshAdminAuctionQuery} />
      </div>}


    </div>
  )
}
